import { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

import * as UI from '@/components/componentLibrary'
import { SpatialPolicy as Policy } from '@/models/spatialPolicy'
import { isEmpty } from '@/modules/map/utils'

import { HideableField } from '../components'
import { EditableFieldProps } from '../types'

import './index.scss'

const MAXIMUM_TITLE = 'Maximum'

export const Maximum = ({ policy, ...props }: { policy: Policy }) => {
  const { t } = useTranslation()
  return (
    <HideableField
      hidden={!policy.maximum && policy.maximum !== 0}
      titleText={t('policiesLibrary.formMaximumTitle', MAXIMUM_TITLE)}
      {...props}
    >
      <UI.Input
        className="policies-table-form-maximum"
        editable={false}
        name="maximum"
        value={isEmpty(policy.maximum) ? '' : policy.maximum}
      />
    </HideableField>
  )
}

export const EditableMaximum = ({
  editable,
  editPolicy,
  onValidate,
  policy,
  ...props
}: EditableFieldProps) => {
  const { t } = useTranslation()

  return editable ? (
    <HideableField
      editable
      titleText={t('policiesLibrary.formMaximumTitle', MAXIMUM_TITLE)}
      {...props}
    >
      <UI.Input
        className="policies-table-form-maximum"
        editable
        error={props.error}
        name="maximum"
        type="number"
        onBlur={onValidate}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          const { value } = e.target
          if (isEmpty(value)) editPolicy?.(p => p.setMaximum(null))
          else {
            const parsed = Number.parseInt(value, 10)
            editPolicy?.(p => p.setMaximum(Number.isNaN(parsed) ? null : parsed))
          }
        }}
        placeholder="00"
        value={isEmpty(policy.maximum) ? '' : policy.maximum}
      />
    </HideableField>
  ) : (
    <Maximum policy={policy} {...props} />
  )
}
